import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Footer() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-foreground text-background overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-background/15">
          <div className="md:col-span-6">
            <p className="font-deva text-primary text-4xl mb-4">नवजीवन</p>
            <p className="font-display font-extrabold text-3xl md:text-4xl tracking-tight max-w-md leading-tight">
              A new life for the Hindi language.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="overline text-background/50 mb-4">Reach us</p>
            <p className="font-body text-background/90">{settings?.email}</p>
            <p className="font-body text-background/90">{settings?.phone}</p>
            <p className="font-body text-background/70 mt-3 text-sm">
              {settings?.address}
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="overline text-background/50 mb-4">Explore</p>
            <ul className="space-y-2 font-body text-background/90 text-sm">
              <li>
                <a href="#courses" className="link-underline">Courses</a>
              </li>
              <li>
                <a href="#about" className="link-underline">Philosophy</a>
              </li>
              <li>
                <a href="#contact" className="link-underline">Enquire</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8">
          <p className="font-body text-xs text-background/50">
            © {new Date().getFullYear()} Navjeevan Hindi Institute. All rights
            reserved.
          </p>
          <Link
            to="/admin/login"
            data-testid="footer-admin-link"
            className="font-body text-xs text-background/50 hover:text-primary transition-colors"
          >
            Admin Login
          </Link>
        </div>
      </div>

      <div
        aria-hidden
        className="font-deva text-background/[0.06] text-[24vw] leading-[0.7] text-center select-none pointer-events-none -mt-8"
      >
        हिंदी
      </div>
    </footer>
  );
}
